import React, { FC, useState } from "react"
import cn from "classnames"
import Arrow from "@assets/svg/arrow.svg"

import style from "./style.m.scss"

type Props = {
  title: string
  content: string | React.ReactNode
}

const Collapse: FC<Props> = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleCollapse = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div onClick={toggleCollapse} className={style.collapse}>
      <div className={style.header}>
        <h3 className={style.title}>{title}</h3>
        <div className={cn(style.arrow, isOpen && style.rotate)}>
          <Arrow />
        </div>
      </div>
      <div className={cn(style.content, isOpen && style.visible)}>{content}</div>
    </div>
  )
}

export default Collapse
